
import React from "react";
import './drinks.css';
import drinks from '../../assets/drinkstower.jpg';
import newin from '../../assets/newinmenu.jpg';
import matcha from '../../assets/twocupsmatcha.jpg';

function Drinks(){
    return (
        <>
        <div>
            <h2 id="menuhead" >Drinks Menu</h2>    
        </div>
        <div className="container menuitems">
 
 <div className="row">
     <div className="col">
         <h3 classNameName="card-title  drinktype">Ice Cold Drinks</h3>
         <p classNameName="card-text">To keep you cool...</p>
     <div classNameNameName="drinks">
         <div classNameName="card" >
         <img src={drinks} classNameName="card-img-top" alt="drinktower" />
                 
             <div classNameName="card-body">
                 <h5 classNameName="card-title">Coffee Based</h5>
                 <ul className="list-group">
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                         <label className="form-check-label" for="firstCheckbox">Mon Frappe</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                         <label className="form-check-label" for="secondCheckbox">Mon Mocha</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Mon Oreo Frappe</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Mon Coffee Jelly</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Mon Spanish Latte</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Mon Caramel Macchiato</label>
                     </li>                
                     
                 </ul>
             </div>

             <div classNameName="card-body">
                 <h5 classNameName="card-title ">Non-Coffee Based</h5>
             <ul className="list-group">
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                     <label className="form-check-label" for="firstCheckbox">Mon Cocoa</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                     <label className="form-check-label" for="secondCheckbox">Dark Cocoa</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Oreo Cocoa</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Oreo Cream</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Oreo Berry</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Mon Matcha</label>
                 </li>                
                 
                 </ul>
             </div>

             <div>
                 <br/>
             </div>

             <div classNameName="card-body">
                 <h4 classNameName="card-title drinktype" >Hot Drink</h4>
             <ul className="list-group">
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                     <label className="form-check-label" for="firstCheckbox">Coffee</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                     <label className="form-check-label" for="secondCheckbox">Mocha</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Choco</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Dark Choco</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Caramel Macchiato</label>
                 </li>
                 <li className="list-group-item">
                     <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                     <label className="form-check-label" for="thirdCheckbox">Matcha</label>
                 </li>                
                 
                 </ul>
             </div>

         </div>
     </div>
     </div>
     <div className="col">
         <h3 classNameName="card-title"> </h3>  
         <p classNameName="card-text"> </p>
         
         <div classNameName="card-body">
             <h4 classNameName="card-title  drinktype">Fruit Coolers</h4>
             <p>Tea, Yoghurt, or Soda</p>
             <p>served with one sinker</p>
             <img src={newin} classNameName="card-img-top" alt="newdrink" id='newin' />
                 <ul className="list-group">
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                         <label className="form-check-label" for="firstCheckbox">Green Apple</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                         <label className="form-check-label" for="secondCheckbox">Strawberry</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Raspberry</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Lychee</label>
                     </li>
                     
                 </ul>
            </div>
            <div>
             <br/>
            </div>

            <div classNameName="card-body">
             <h4 classNameName="card-title  drinktype">Milk Tea</h4>
             <p>served with one sinker</p>
                 <ul className="list-group">
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                         <label className="form-check-label" for="firstCheckbox">Winter Melon</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                         <label className="form-check-label" for="secondCheckbox">Chocolate</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Okinawa</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Hokkaido</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Taro</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Matcha</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Strawberry</label>
                     </li>
                     
                 </ul>
                 <img src={matcha} classNameName="card-img-top" alt="matcha" id='matcha' />
                 
            </div>

            <div>
             <br/>
            </div>
            <div classNameName="card-body sinker">
             <h4 classNameName="card-title  sinker">Sinkers</h4>
                 <ul className="list-group">
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox"/>
                         <label className="form-check-label" for="firstCheckbox">Oreo</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox"/>
                         <label className="form-check-label" for="secondCheckbox">Nata</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Pearl</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Popping Boba</label>
                     </li>
                     <li className="list-group-item">
                         <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox"/>
                         <label className="form-check-label" for="thirdCheckbox">Coffee Jelly</label>
                     </li>
                     
                 </ul>
            </div>

     </div>
 </div>
</div>
        </>
    )
}

export default Drinks;
